export const artistList = [
  { name: "Muto Yuya", img: "muto", link: "https://mutoyuya.com/tokyo" },
  { name: "mikehige", img: "mikehige", link: "https://oncyber.io/voenista" },
  { name: "KINTOKI", img: "kintoki", link: "https://twitter.com/kintokey_zoo" },
  { name: "rippi", img: "rippi", link: "https://twitter.com/rippi37" },
  {
    name: "Tsumichara",
    img: "tsumichara",
    link: "https://linktr.ee/tsumichara",
  },
  { name: "Lily-K", img: "lily-k", link: "https://twitter.com/NFT_Artworld" },
  {
    name: "Tagawa Makoto",
    img: "tagawa",
    link: "https://linktr.ee/tagawamakoto",
  },
  {
    name: "Hiroaki Hasumi",
    img: "hasumi",
    link: "https://www.hasumi.photography/",
  },
  {
    name: "hasaqui yamanobe",
    img: "hasaqui",
    link: "https://www.hasaqui.com/digitalworks",
  },
  {
    name: "RIBBON",
    img: "ribbon",
    link: "https://lit.link/RIBBON",
  },
  {
    name: "magome",
    img: "magome",
    link: "https://twitter.com/i/events/1498621542132895745",
  },
  {
    name: "Shin Ringo",
    img: "shin-ringo",
    link: "https://lit.link/shinringoart",
  },
  {
    name: "Sawaco",
    img: "sawaco",
    link: "https://linktr.ee/sawacon",
  },
  {
    name: "Saori",
    img: "saori",
    link: "https://linktr.ee/sa0ri",
  },
  {
    name: "AURORA",
    img: "aurora",
    link: "https://linktr.ee/raykajp",
  },
  {
    name: "zawawa",
    img: "zawawa",
    link: "https://opensea.io/collection/zawawa-forest",
  },
  {
    name: "ONE a.k.a give me IQ",
    img: "one",
    link: "",
  },
  {
    name: "Izuru Shinonome",
    img: "izuru",
    link: "https://izuru01.tumblr.com/",
  },
  {
    name: "Little Artist CHIBI",
    img: "chibi",
    link: "https://twitter.com/Artist7yChibi",
  },
  {
    name: "Emma",
    img: "emma",
    link: "https://twitter.com/Emma3NFT",
  },
  {
    name: "gamaccho",
    img: "gamaccho",
    link: "https://gamaccho.com/",
  },
  {
    name: "Satoshi Miyachi",
    img: "miyachi",
    link: "https://twitter.com/miyachi_satoshi",
  },
  {
    name: "Reilly illustration",
    img: "reilly",
    link: "https://www.instagram.com/reilly.illustration/",
  },
  {
    name: "Little People",
    img: "little-people",
    link: "https://twitter.com/wyoook",
  },
  {
    name: "NauGhtEd",
    img: "naughted",
    link: "https://twitter.com/NauGhtEd_eth",
  },
  {
    name: "kumoxel",
    img: "kumoxel",
    link: "https://www.instagram.com/kumoxel/",
  },
  {
    name: "Shiro1",
    img: "shiro1",
    link: "https://www.instagram.com/shiro_one/",
  },
  {
    name: "Miura Donuts",
    img: "miura-donuts",
    link: "https://twitter.com/WinstonDreamer",
  },
  {
    name: "mera takeru",
    img: "mera-takeru",
    link: "https://linktr.ee/mera_takeru",
  },
  {
    name: "Ladybrown",
    img: "ladybrown",
    link: "https://twitter.com/LadybrownArt",
  },
  {
    name: "(((o)))",
    img: "o",
    link: "https://www.instagram.com/k00m00/",
  },
  {
    name: "TAKUROMAN",
    img: "takuroman",
    link: "https://www.takuroman.com/",
  },
  {
    name: "Hikage",
    img: "hikage",
    link: "https://twitter.com/Hikage369nft",
  },
  {
    name: "kikkawa keita",
    img: "kikkawa",
    link: "https://keitymouse.com/",
  },
  {
    name: "BroccoliSP",
    img: "broccolisp",
    link: "https://twitter.com/burokkooori",
  },
  {
    name: "SHIS",
    img: "shis",
    link: "https://www.inashis.com/",
  },
];

export const teamList = [
  {
    name: "ikeryou",
    img: "team/ikeryou",
    link: "https://twitter.com/ikeryou",
  },
];

export const menuList = [
  { label: "Top", id: "top" },
  { label: "About", id: "about" },
  { label: "NFT", id: "nft" },
  { label: "Artists", id: "artists" },
  { label: "Yokai", id: "yokai" },
];

export type Tip = {
  title: string;
  text: string;
};

export const tipsList: Tip[] = [
  {
    title: "About Hyakki Yako",
    text: "Sometimes an orderly procession, other times a riot, it refers to a parade of thousands of supernatural creatures known as oni and yōkai that march through the streets of Japan at night.  As a terrifying eruption of the supernatural into the real world, it is similar (though not precisely equivalent) to the concept of pandemonium in English. (From wiki)",
  },
  {
    title: "Makimono",
    text: "Have you ever seen Japanese picture scrolls called “Makimono”? This makimono is a very huge part of our Japanese history and culture, in fact, there is still a lot of mystery and things that we haven’t found out yet. So, what is it? An Emaki usually consists of two things, text and illustration. The text generally comes first and tells the story, then the Illustration shows many scenes from it. Most Emaki are made with Washi (Japanese traditional paper) if you might have heard of it.",
  },
];

export const twitterLink = "https://twitter.com/3600YAKO";

export const footerLinks = [
  {
    label: "Terms of use",
    url: "http://example.com",
  },
  {
    label: "Privacy Policy",
    url: "http://example.com",
  },
  {
    label: "Docs",
    url: "http://example.com",
  },
  {
    label: "Twitter",
    url: "http://example.com",
  },
  {
    label: "Discord",
    url: "http://example.com",
  },
  {
    label: "36FUJI",
    url: "http://example.com",
  },
];

export type YokaiArt = {
  name: string;
  text: string;
  icon: string;
  nameImg: string;
};

export type Yokai = {
  default: {
    name: string;
    text: string;
  };
  artist: YokaiArt[];
};

export const kappa = {
  default: {
    name: "kappa",
    text: "“Kappa” is an amphibious Yokai said to inhabit ponds or rivers in Japan. They are typically depicted as green and turtle-like feet. The description itself varies from region to region, but all Kappa has a small bowl-like dent on top of their heads that holds a small pool of water. The word “Kappa” translates roughly to “water child”. Some kappa just enjoys causing mischief and trouble towards humans, but some Kappa is dangerous and has been known to try to kidnap kids and eat them. What a scary guy...",
  },
  artist: [
    {
      name: "kappa",
      text: "A Yokai that lives by the riverside and has a beak and a plate on her head. She protects the plate because it will make her feel sick if she loses it. Her favorite food is cucumbers.",
      icon: "shin-ringo",
      nameImg: "text",
    },
    {
      name: "OkappaSama",
      text: "A Kappa with a bob haircut who loves Sumo and cucumbers. He’s small and a little bit round, and even looks not reliable, but if you need to watch out because he might pull his buttocks out…ya I told you.",
      icon: "kikkawa",
      nameImg: "kikkawa-txt",
    },
    {
      name: "Kappa",
      text: "The Kappa freely dives into people’s hearts, and he likes surprising people and playing with them! It might seem that Kappa is not a friendly Yokai, but he’s really trying hard to bring smiles to people, sometimes he feels he’s lost as we humans do in this society. When the hard times come, he will take off the shell, a deep breath, and just enjoys a relaxing Onsen. That’s what he decides to do in order to overcome it.",
      icon: "tagawa",
      nameImg: "tagawa-txt",
    },
  ],
};

export const tengu = {
  default: {
    name: "tengu",
    text: "“Tengu” is originally known as evil spirits that caused destruction wherever they went like carrying off monks and robbing temples, but they are seen as good or bad depending on the story. They are known as good protectors sometimes. All the Tengu has a red face with a long nose carrying a fan.",
  },
  artist: [
    {
      name: "Haretengu",
      text: 'The name "Tengu" comes from the fact that a Tengu saw a child lost in the rain one day and used his fan to remove the rain clouds and make it sunny. He is a rare Tengu who likes playing with kids, which is why he wears a jersey that looks like PE clothes.',
      icon: "broccolisp",
      nameImg: "broccolisp-txt",
    },
    {
      name: "Non Fungible TENGU",
      text: `The Tengu is described in the Tale of the Heike as "a man without a man, a bird without a bird, a dog without a dog, a man with legs and hands, a dog with a head, feathers on both sides, and a thing that flies and walks. It is the one and only being that cannot be categorized as anything else. We all want to live like that, don't we? In this work, I drew the tengu, which is usually feared by many people, as a familiar one with a sense of minimalism.`,
      icon: "takuroman",
      nameImg: "takuroman-txt",
    },
    {
      name: "Miguel-Martin",
      text: `Yokai “Miguel” was living quietly deep in the mountains in the countryside, but a large construction suddenly begins, then trees are cut down, and they made a large facility for camping where lots of crazy party people gather. Of course, Miguel is mad at it and heads to the facility to bring trouble to the people who come there. But what he finds was the party people playing music, grilling meat, and dancing and making noise as if it were a festival! Miguel gets confused about what’s going on because he’s been living in the mountain for a long time, he wanted to join them but didn't have the courage so all he did was just watch on that day. Another day, they are watching “Back to the Future2” on a big screen, Miguel quietly walks up to them and sits in a beanbag with them. Yes, he is a Yokai, but he loves that kind of stuff too like every other human. So he enjoyed it and decided to go off the mountain, and pulls out the suit that he hasn't worn for hundreds of years to try to be the “Party people”.`,
      icon: "naughted",
      nameImg: "naughted-txt",
    },
  ],
};

export const kitsunebi = {
  default: {
    name: "Kitsunebi",
    text: `“Kitsunebi” is what we call “fox fire”. They appear as floating balls of light at night. There can be a long line of the Kitsunebi as if there are lanterns carried by someone invisible, that’s Kitsune (fox). By the way, following kitsunebi is never a good idea. They only lead people to places they should not be like luring humans into the darkness towards a group of hungry Yokai. So please be careful. `,
  },
  artist: [
    {
      name: "ShiroKitsunebi",
      text: "Please be careful walking alone on the mountain roads at night, because she might take you to a parallel world.",
      icon: "shiro1",
      nameImg: "shiro1-txt",
    },
    {
      name: "KitsuneBi",
      text: `On full moon nights, Kitsunebi is appearing to surround the fox with very kind eyes. When this happens, even the normally beautiful red spider lily flowers look like flames.`,
      icon: "ladybrown",
      nameImg: "text",
    },
    {
      name: "Kitsunebi Boy",
      text: `This kitsunebi is a really kind Yokai. When the road is dark and scary, he will come to shine a light for us.`,
      icon: "chibi",
      nameImg: "chibi-txt",
    },
  ],
};

export const nekomata = {
  default: {
    name: "Nekomata",
    text: `“Nekomata” is said to have powers of necromancy, and upon raising the dead, will control them with ritualistic dances using their paw and tail. They even use their powerful influence to blackmail or enslave humans into doing their bidding. By the way, people say that the most dangerous Nekomata live in the deep mountains. `,
  },
  artist: [
    {
      name: "Nekomata",
      text: `An old cat that has become a yokai with two tails after gaining mystical powers suddenly. He speaks human languages and sometimes shows love to the owners. He also likes gathering together with other Nekomata to enjoy “Bon Odori (Japanese Festival)”. “Tenugui (hand towels)” is a must for the Bon Odori.`,
      icon: "izuru",
      nameImg: "text",
    },
    {
      name: "CatWoman",
      text: `I am a Nekomata and it’s been hundreds of years since I became a Yokai. By the way, do you know a Japanese instrument called “Shamisen”? I love the sound of it and am practicing for a while, now I can even play the electronic Shamisen to make a parade with my other Yokai friends! Don’t miss my solo part! Are you guys ready?`,
      icon: "lily-k",
      nameImg: "text",
    },
    {
      name: "Nekomata-猫魔多",
      text: `A beautiful cat girl Yokai born from a human who was obsessed with cats. She deceives people and sometimes takes their lives. Their souls will always stay with her…`,
      icon: "aurora",
      nameImg: "aurora-txt",
    },
  ],
};

export const inugami = {
  default: {
    name: "Inugami",
    text: `“Inugami” is a very powerful Yokai possessing emotionally unstable and weak people. He’s looking for it and trying to get inside you. Once you got possessed by an Inugami, you are in for some serious misfortune. The signs of the possession are chest pain, hand pain, feelings of deep jealousy, and suddenly barking like a dog. The only way to cure is to hire another sorcerer to remove it. But we never know if it will work. It’s not that easy. It’s said that the possession could be passed on to their families... `,
  },
  artist: [
    {
      name: "Inugami",
      text: `A new Inugami born to purify the souls of his friends. He has the elegance and split into 10 bodies from the initial one. This Inugami follows no one as he freely flies through the air, sharing the pearl as a bond. `,
      icon: "saori",
      nameImg: "text",
    },
    {
      name: "Inugami",
      text: `Those who get possessed by an Inugami are said to bark like dogs and become lunatics. In Japanese folklore, this is portrayed as a kind of curse. It has been told by the locals that Inugami serves the clan that controls it.`,
      icon: "kintoki",
      nameImg: "text",
    },
    {
      name: "Inugami",
      text: `The Inugami, who was feared as a possessor, originates from the heartless resentment of human beings. Shamanism flourished in the world before science once extended beyond people to animals in Japan. In the Yamato Language, there is a word "Tsuku," which is used today as a positive meaning as in "today is my lucky day" but originally it was a negative expression, "possession. Giving us an opportunity to reconsider the two sides of things.`,
      icon: "muto",
      nameImg: "text",
    },
  ],
};

export const oni = {
  default: {
    name: "Oni",
    text: `“Oni” is the greatest icon of Japanese folklore. They are tall and scary having red or blue skins with two or three horns. Oni is said to live in hell where they work for Great Lord “Enma”. They are basically servants of this Enma. Their work? Their work is to mete out horrible punishments for wicked sinners...`,
  },
  artist: [
    {
      name: "Walking Oni",
      text: `There are stories back in the day that Oni has inhabited many parts of Japan. There is even a tradition of throwing beans on a day called “Setsubun” to stay the Oni away. Oni can be scary, but not all of them are. This Oni is so kind and was born with cute taste using dots.`,
      icon: "rippi",
      nameImg: "rippi-txt",
    },
    {
      name: "Kimi-鬼魅",
      text: `Once upon a time, only “power” was all that mattered in the world of Oni, but now “fashion” comes into vogue. In the year 2022, it has been carried over to today, and the girls, the children of the family, are still enjoying wearing outfits with their sense of style.`,
      icon: "zawawa",
      nameImg: "zawawa-txt",
    },
    {
      name: "OniOnna",
      text: `She is a Yokai of the embodiment of the soul of women’s desire and grudges gathered together. She just looks like a human being but has horns on her head, and a large body.`,
      icon: "little-people",
      nameImg: "little-people-txt",
    },
  ],
};

export const dokuro = {
  default: {
    name: "Dokuro",
    text: `“Dokuro” is created when people who couldn't find piece and die unknown in the wilderness rarely have proper burial. The causes of this could be sickness, starvation and even war as there would be so much anger and pains. Their souls are reborn as ghosts longing eternally for the things they once had. The more anger natured is within them, the longer they will live. Only way they can die naturally if that anger fades away... `,
  },
  artist: [
    {
      name: "Shari Kobe",
      text: `A skull specter is said to have been born from the cremated remains of the Buddha. Its body is made of grains of rice, and it is said that if you encounter it on an empty stomach, it will share some of its body with you.`,
      icon: "mera-takeru",
      nameImg: "text",
    },
    {
      name: "OshareKobe",
      text: `She is a bit sad Yokai because she doesn't want to scare or hurt people so she decides to dress up in flowers, but unfortunately, this makes her even scarier which she hasn't realized yet. She typically haunts those who wear some follower shirts, and old clothes are her favorite. The most favorite food of hers is Tsubu-An (Smashed sweet red bean).`,
      icon: "hikage",
      nameImg: "hikage-txt",
    },
    {
      name: "Decorator Skull",
      text: `A skull Yokai that has the ability to transform itself by mimicking its surroundings and incorporating waste wood and animal bodies into its own body.`,
      icon: "o",
      nameImg: "text",
    },
  ],
};

export const yukiOnna = {
  default: {
    name: "YukiOnna",
    text: `“Yuki-Onna” is probably the most good-looking beautiful Yokai if you look at other Yokai, but you better watch out. She lives near mountains trying to prey on travelers lost on the road or break into houses to flash freeze the people inside during the night. But she is not entirely cold-blooded actually. Some guys go too far and fall in love with the intended prey and beauty. But the end of the love is always the same when the husband finds out who she is...`,
  },
  artist: [
    {
      name: "YukiOnna",
      text: `A female Yokai wearing a white robe. She shows up on a very cold night in the snowy country trying to approach humans. She is a very beautiful woman, but her hands are always cold like ice and she hides her true self. It’s because she has a very sad past…`,
      icon: "sawaco",
      nameImg: "text",
    },
    {
      name: "YukiOnna",
      text: `This Yuki Onna was originally a girl who lost her life when she went out looking for her sister who did not come back on a blizzard day. She’s been spending days and days when it snows looking for her sister, but still can't find. So she's now spending her free time making snowmen and playing with them. Sugar cubes are her favorite food.`,
      icon: "emma",
      nameImg: "text",
    },
    {
      name: "Yukimura San",
      text: `Yukimura is a snowwoman who came to Tokyo from her hometown in the snow country, dreaming of a bright life. She doesn’t like winter which is the reason why she left but unexpectedly realized that the winter in Tokyo is so cold as well. While going to college, she works at a cafe near the station, but when she makes hot coffee, it always got cold.`,
      icon: "miura-donuts",
      nameImg: "miura-donuts-text",
    },
  ],
};

export const rokurokubi = {
  default: {
    name: "Rokurokubi",
    text: `“Rokurokubi” is just like an ordinary woman except for the time when she sleeps. At the night, her body sleeps while her neck stretches out to incredible heights and moves around freely. She might now kill you, but she likes to scare people and make trouble by licking up some lamp oil with their long tongues and attacking small animals.`,
  },
  artist: [
    {
      name: "Rokurokubi 2022",
      text: `The Rokurokubi stretches its neck out at night to lick the oil from the lanterns and has been mainly depicted as a young female Yokai. “Oiran”, the courtesan, is the model for this work, which is a modern version of rokurokubi with animated touches.`,
      icon: "hasumi",
      nameImg: "text",
    },
    {
      name: "Funky Rokurokubi",
      text: `Even the moonlight is too bright for her because she has a long neck. She shields herself with the excuse that sunglasses are a must even at night. In fact, she sometimes closes her eyes and walks around relying only on the sunglasses to enjoy the thrill of being turned into a balloon that might break up! She is interesting and cute, isn't she?`,
      icon: "shis",
      nameImg: "text",
    },
    {
      name: "hanamaki",
      text: `She loves the tattoo on her long neck but usually keeps it down to fit the body. Her favorite food?? It’s ice cream. She just falls in love with it.`,
      icon: "ribbon",
      nameImg: "ribbon-txt",
    },
  ],
};

export const nue = {
  default: {
    name: "Nue",
    text: `“Nue” is one of the oldest Yokai having its first appearance in Kojiki. The Nue has the head of a monkey, the body of a raccoon, the tail of a snake, and the legs of a tiger. The Nue is said to have the ability to transform into a black could and fly.`,
  },
  artist: [
    {
      name: "Nue",
      text: `A legendary yokai that has the face of a monkey, the body of a raccoon, and even the legs of a tiger with the tail of a snake. You never know what he’s thinking, so the rumor is that he’s embodying the current crypto spaces. He sings like “hyo-hyo-hyo”, but it’s actually “LFG LFG” lol`,
      icon: "gamaccho",
      nameImg: "text",
    },
    {
      name: "Nue",
      text: `A Yokai with a monkey face, raccoon body, tiger arms and legs, and snake tail that comes in the “Tale of the Heike” and is depicted as a monster in there. He is literally a Yokai, but cute right?`,
      icon: "tsumichara",
      nameImg: "text",
    },
    {
      name: "Nue",
      text: `According to some studies, monkeys and snakes do not get along with each other because every time they find food, they argue about who will eat it. But, recent research has revealed that they were actually good friends! No argument anymore!`,
      icon: "magome",
      nameImg: "text",
    },
  ],
};

export const nurarihyon = {
  default: {
    name: "Nurarihyon",
    text: `“Nurarihyon” is a mysterious and very powerful Yokai. Nurarihyon is known as the commander and leader of all the Yokai. So every Yokai listens to him and respect him so much. That goes to show that Nurarihyon wears a splendid kimono most of the cases. `,
  },
  artist: [
    {
      name: "VoeNurarihyon",
      text: `Elusiveness! Fearlessness! These two words are really for this Yokai, Voe Nurarihyon…He comes into houses and eats the food there, and he doesn't even care about doing it. But he finally got caught by a brave man “Mikehige”, and had his head shaped like “Nu(ぬ)”. He doesn't notice it yet. His hobby is doing a fashion show “by himself”. `,
      icon: "mikehige",
      nameImg: "text",
    },
    {
      name: "NurariYamamoto",
      text: `The secrets to his good health even at the age of 500 are that he eats softshell turtle and kappa every day.`,
      icon: "miyachi",
      nameImg: "miyachi-text",
    },
    {
      name: "hq Nurarihyon",
      text: `Nurarihyon is a mysterious yokai as it’s known as "Nurari" and "Hyon" spoken of as something elusive like a catfish or an octopus while it is seen as the boss of yokai in the modern day. This Nurarihyon has been created as something with mysterious power as well as something that encourages us to have such power. I felt that I needed to make the process "Nurari" and develop the idea of "Hyon" as if I were this yokai.`,
      icon: "hasaqui",
      nameImg: "text",
    },
  ],
};

export const kamaitachi = {
  default: {
    name: "Kamaitachi",
    text: `“Kamaitachi” lives near mountain and attack people in threes. The first one slices at people’s leg to know him down to the ground and the second eves slice up more of the prone victim with thousands of dreadful cuts. But the third one gives a magical salve that heals up the wounds instantly. They move too fast to perceive them. So from his perspective, he thinks he just trips and gets up with a bit of pain and a few scratches here and there. `,
  },
  artist: [
    {
      name: "KamatteChan",
      text: `The Yokai with 3 siblings. He is cute and friendly to humans, but once you become friends with them and you are cold to them or even leave them for a while, they’ll turn into very terrifying Yokai…!`,
      icon: "one",
      nameImg: "one-txt",
    },
    {
      name: "Kamaitachi",
      text: `Kamaitachi is a weasel Yokai with sharp claws like a sickle on the tips of its feet. They come out with a whirlwind and attack humans. They always act in a group of three and hurt humans as a team… So the first one makes the target fall down and the second one will cut him up, then the last one will take care of the cut to make it look like only a scratch. They are just too fast to do it so are almost invisible. They love “Soba”, but don't like thunder.`,
      icon: "kumoxel",
      nameImg: "text",
    },
    {
      name: "Wind Fairy",
      text: `“Wind fairy” suddenly appearing in the air has a strong gravitational pull, and has the power to become the eye of a typhoon. A yokai that attracts people and luck. Another name is also called Kamaitachi in Japanese.`,
      icon: "reilly",
      nameImg: "text",
    },
  ],
};
export const yokaiZukan = [
  kappa,
  tengu,
  kitsunebi,
  nekomata,
  inugami,
  oni,
  dokuro,
  yukiOnna,
  rokurokubi,
  nue,
  nurarihyon,
  kamaitachi,
];
